var colors = require('../colors');

module['exports'] = function (letter, i, exploded) {
  return i % 2 === 0 ? letter : colors.inverse(letter);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/colors/lib/maps/zebra.js
// module id = 684
// module chunks = 14